import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TooltipOnEllipsis from '../tooltipOnEllipsis/tooltipOnEllipsis';
import compose from '../../hoc/compose';
import { dataHooks } from './constants';

var Button = function Button(_ref) {
  var getClassName = _ref.getClassName,
      automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      ellipsis = _ref.ellipsis,
      children = _ref.children,
      type = _ref.type,
      fullWidth = _ref.fullWidth,
      prefixIcon = _ref.prefixIcon,
      suffixIcon = _ref.suffixIcon;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(getClassName('control-button'), {
      'with-ellipsis': ellipsis
    }, {
      'full-width': fullWidth
    }, {
      'suffix-icon': suffixIcon
    }, {
      'prefix-icon': prefixIcon
    }),
    "data-enable-ellipsis": ellipsis,
    "data-aid": automationId,
    "data-hook": dataHook,
    disabled: disabled ? 'disabled' : '',
    onClick: onClick,
    type: type
  }, /*#__PURE__*/React.createElement("div", {
    className: "button-content"
  }, prefixIcon && /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.prefixIcon,
    className: "prefix-icon"
  }, prefixIcon), ellipsis ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, null, children) : children, suffixIcon && /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.suffixIcon,
    className: "suffix-icon"
  }, suffixIcon)));
};

Button.displayName = 'Button';
Button.propTypes = {
  /** content to be displayed */
  children: PropTypes.any,

  /** make the component to be disabled and stop click events */
  disabled: PropTypes.bool,

  /** triggered when button is clicked */
  onClick: PropTypes.func,

  /** wrap content with tooltipOnEllipsis */
  ellipsis: PropTypes.bool,

  /** button type attribute: submit, reset or button */
  type: PropTypes.string,

  /** make the button fill its container width */
  fullWidth: PropTypes.bool,

  /** Element based icon (svg, image etc.)*/
  suffixIcon: PropTypes.element,

  /** Element based icon (svg, image etc.)*/
  prefixIcon: PropTypes.element
};
Button.defaultProps = {
  fullWidth: false
};
export default compose(Button);